import axios from "axios";
import { Component } from "react";
import jwt_decode from "jwt-decode";
const qs = require("query-string");

const ID_URL = process.env.REACT_APP_ID.split("?")[0];

axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("user")) {
      const jwt = JSON.parse(localStorage.getItem("user")).jwt;
      config.headers["Authorization"] = jwt;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      const user = JSON.parse(localStorage.getItem("user"));
      originalRequest._retry = true;

      try {
        const tokenResponse = await axios.post(
          `${ID_URL}api/auth/refresh-token`,
          {},
          {
            headers: { Authorization: user.jwt },
          }
        );
        const token = tokenResponse.data.data.token;

        axios.defaults.headers.common["Authorization"] = token;
        const tokenDecoded = jwt_decode(token);

        const userResponse = await axios.get(`${ID_URL}api/user/data`);
        const roles = userResponse.data.data.roles;

        if (
          !["POSMO_DATAPROFILER", "SUPERUSER"].some((role) =>
            roles.defaults.roles.includes(role)
          )
        ) {
          return (window.location.href = process.env.REACT_APP_ID);
        }

        localStorage.setItem(
          "user",
          JSON.stringify({
            user_id: tokenDecoded.sub,
            roles: roles,
            exp: tokenDecoded.exp,
            jwt: token,
          })
        );

        return axios(originalRequest);
      } catch (err) {
        localStorage.removeItem("user");
        console.error(err);
        window.location.href = process.env.REACT_APP_ID;
      }
    }
  }
);

export default function Authentication(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      const user = localStorage.getItem("user");

      if (!user) {
        const search = qs.parse(window.location.search);
        if (!search.t) {
          window.location.href = process.env.REACT_APP_ID;
        } else {
          try {
            const token = search.t;
            const tokenDecoded = jwt_decode(token);

            if (tokenDecoded.exp < Date.now()) {
              window.location.href = process.env.REACT_APP_ID;
            }

            axios.defaults.headers.common["Authorization"] = token;

            axios
              .get(`${ID_URL}api/user/data`)
              .then((response) => {
                const roles = response.data.data.roles;
                if (
                  !["POSMO_DATAPROFILER", "SUPERUSER"].some((role) =>
                    roles.defaults.roles.includes(role)
                  )
                ) {
                  window.location.href = process.env.REACT_APP_ID;
                }

                localStorage.setItem(
                  "user",
                  JSON.stringify({
                    user_id: tokenDecoded.sub,
                    roles: roles,
                    exp: tokenDecoded.exp,
                    jwt: token,
                  })
                );

                window.location.href = window.location.href.split("?")[0];
              })
              .catch((err) => {
                console.error(err);
                window.location.href = process.env.REACT_APP_ID;
              });
          } catch (err) {
            console.error(err);
            window.location.href = process.env.REACT_APP_ID;
          }
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
